import React from "react";
import KendoUploadField from "./KendoUploadField";

export default function FileUploadField({
  field,
  required,
  error,
  files,
  allowedExtensions,
  fileSizeLimit,
  limitOfFileNumber,
  onUploadSuccess,
  onRemoveSuccess,
  disabled,
}) {
  return (
    <div className="col-md-6 mb-md-4">
      <KendoUploadField
        fieldId={field.id}
        title={field.title}
        placeholder={field.placeholder}
        required={required}
        labelInfoPopover={field.labelInfoPopover}
        description={field.description}
        disabled={disabled}
        multiple={false}
        currentFiles={files}
        allowedExtensions={allowedExtensions}
        fileSizeLimit={fileSizeLimit}
        limitOfFileNumber={limitOfFileNumber}
        invalid={error}
        styleVariant="payload"
        onUploadSuccess={(uploadedFile) => onUploadSuccess(field, uploadedFile, false)}
        onRemoveSuccess={onRemoveSuccess}
      />
    </div>
  );
}
